import { render, staticRenderFns } from "./ProductAddons.vue?vue&type=template&id=43eb4f22&scoped=true&"
import script from "./ProductAddons.vue?vue&type=script&lang=js&"
export * from "./ProductAddons.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddons.vue?vue&type=style&index=0&id=43eb4f22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43eb4f22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VContainer,VList,VListItem,VListItemContent,VListItemIcon,VListItemSubtitle,VListItemTitle})
